'use client';
import { Map, MapProps } from '@vis.gl/react-google-maps';
import { useThemeState } from 'contexts/theme/ThemeContext';
import { AquaSpecies } from 'types/shared/aqua-species.type';
import React, { useEffect, useState } from 'react';
import { aquaStyle, ewosStyle } from './assets/map-styles';

type Props = MapProps & {
  siteId?: string;
  children?: React.ReactNode;
  enableFullScreen?: boolean;
  center?: google.maps.LatLngLiteral;
  editLocation?: boolean;
};

const GoogleMaps: React.FC<Props> = ({
  children,
  center = { lat: 60.3913, lng: 5.3221 }, // Bergen, Norway
  enableFullScreen = false,
  maxZoom = 7,
  minZoom = 1,
  ...props
}) => {
  const { aquaSpecies } = useThemeState();

  //#region STATES
  const [mapStyle, setMapStyle] = useState<google.maps.MapTypeStyle[]>(ewosStyle);
  //#endregion STATES

  //#region HOOKS

  useEffect(() => {
    if (aquaSpecies === AquaSpecies.shrimp) setMapStyle(aquaStyle);
    else {
      setMapStyle(ewosStyle);
    }
  }, [aquaSpecies]);

  //#endregion HOOKS

  return (
    <Map
      {...props}
      defaultZoom={5}
      defaultCenter={center}
      styles={mapStyle}
      maxZoom={maxZoom}
      minZoom={minZoom}
      mapTypeControl={false}
      streetViewControl={false}>
      {children}
    </Map>
  );
};

export default React.memo(GoogleMaps);
